import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {} from '@lingaai/shared-hooks';
import { useCurrentUser } from '@lingaai/user-management';
import { CircularProgress, Box } from '@mui/material';
import { AdminDashboard } from './AdminDashboard';
import { PortCoDashboard } from './PortCoDashboard';

export function Dashboard() {
  const { data: user, isLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role === 'super_admin') {
      navigate('/super-admin/tenants', { replace: true });
    }
  }, [user, navigate]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return null;

  if (user.role === 'super_admin') {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (user.role === 'admin') return <AdminDashboard />;
  if (user.role === 'portco') return <PortCoDashboard />;

  return null;
}
